import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWifiSignal4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "wifi-signal-4" }),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "7.5 23.248 12 11.248 12 8.248 12 11.248 16.5 23.248"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.726.747a9,9,0,0,1,0,15"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.5,4.575a5.249,5.249,0,0,1,0,7.347"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.275.747a9,9,0,0,0,0,15"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.5,4.575a5.251,5.251,0,0,0,0,7.347"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.625,
			y1: 20.248,
			x2: 15.375,
			y2: 20.248
		})
	]
});
export default SvgWifiSignal4;
